import { useEffect } from 'react';
import { useState } from 'react';
import styles from './ErrorPage.module.css';

const ErrorPage = ({error, resetErrorBoundary}) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // send error to Backend
    // setIsLoading(false)
  }, [])

  console.log("error: ", error);
  console.log("error: type ", typeof error);
  console.log("error: props: ", Object.keys(error))
  // console.log("resetErrorBoundary: ", resetErrorBoundary);

  return (
    <div className={styles.screen}>
      <div
        className={`${styles.outerDiv} position-relative d-flex justify-content-center align-items-center`}
      >
        {!isLoading && <div
          className={`${styles.errorContainer} d-flex flex-column justify-content-between align-items-center`}
        >
          <h2 className="text-dark">Something went wrong.</h2>
          {/* {error.message && error.message.length > 0 && <p className="fw-bold mb-1">{error.message}</p>} */}
          <div className={styles.errorImage}></div>
          <button
            onClick={() => (window.location.href = "/home")}
            className={styles.redirect}
            >
            Go to Homepage
          </button>
            <p style={{fontSize: "0.8em"}} className="mt-3 mb-1">If you keep getting this error try refreshing the page.</p>
        </div>}
      </div>
    </div>
  );
}

export default ErrorPage;